import Axios, { AxiosRequestConfig } from "axios";

export const api = Axios.create({
    baseURL: "/v1",
    withCredentials: true,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
    },
});

export const Http = {
    Request: async <A>(options: AxiosRequestConfig): Promise<A> => {
        return new Promise((resolve, reject) => {
            api.request({
                ...options,
                headers: {
                    ...options.headers,
                },
            })
                .then(async (response) => {
                    return resolve(response.data);
                })
                .catch((e) => {
                    reject(e);
                });
        });
    },
};
